import { STATUS_COLORS, STATUS_LABELS } from './types';

import type { TenantStatus } from './types';

/** Ordem de exibição dos status no dashboard. */
const STATUS_ORDER: TenantStatus[] = [
  'active',
  'onboarding',
  'payment_overdue',
  'suspended',
  'churning',
  'churned',
  'archived',
];

interface StatusTotalsCardsProps {
  totals: Partial<Record<TenantStatus, number>>;
  activeFilter: TenantStatus | undefined;
  onFilterChange: (status: TenantStatus | undefined) => void;
}

/**
 * StatusTotalsCards — cards clicáveis por estado de lifecycle.
 *
 * Permite filtrar a lista de Tenants por status clicando no card.
 * Click no card ativo → deseleciona (volta a "todos").
 *
 * D-B: read-only — sem capability gate próprio (gate está no pai TenantLifecyclePage).
 */
export function StatusTotalsCards({
  totals,
  activeFilter,
  onFilterChange,
}: StatusTotalsCardsProps): JSX.Element {
  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(130px, 1fr))',
        gap: 10,
        marginBottom: 20,
      }}
    >
      {STATUS_ORDER.map((status) => {
        const count = totals[status] ?? 0;
        const colors = STATUS_COLORS[status];
        const isActive = activeFilter === status;

        return (
          <button
            key={status}
            type="button"
            onClick={() => {
              onFilterChange(isActive ? undefined : status);
            }}
            aria-pressed={isActive}
            style={{
              padding: '12px 14px',
              borderRadius: 8,
              border: `2px solid ${isActive ? colors.fg : colors.border}`,
              backgroundColor: isActive ? colors.bg : '#fff',
              cursor: 'pointer',
              textAlign: 'left',
              transition: 'border-color 0.15s',
            }}
          >
            <div
              style={{
                fontSize: 22,
                fontWeight: 700,
                color: colors.fg,
                lineHeight: 1,
                marginBottom: 4,
              }}
            >
              {count}
            </div>
            <div style={{ fontSize: 11, fontWeight: 600, color: '#6b7280' }}>
              {STATUS_LABELS[status]}
            </div>
          </button>
        );
      })}
    </div>
  );
}
